import {
  CalendarIcon,
  ChevronUpIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';
import cn from 'classnames';
import dayjs from 'dayjs';
import type { MouseEvent } from 'react';
import { useMemo } from 'react';

import { DATE_FORMAT } from 'utils/dayjs';

import type { DateRangeOption } from 'models/dateRange';

type Props = {
  filter: DateRangeOption;
  isOpen: boolean;
  isCustomOpen: boolean;
  closeCustom: () => void;
  disabled: boolean;
};

export const DateRangeLabel = ({
  filter,
  isOpen,
  isCustomOpen,
  closeCustom,
  disabled
}: Props) => {
  const label = useMemo(() => {
    if (isCustomOpen && isOpen) {
      return 'Select custom range';
    }

    if (filter.value == 'custom') {
      return (
        <>
          {dayjs(filter.range.from).format(DATE_FORMAT)}&nbsp;/&nbsp;
          {dayjs(filter.range.to).format(DATE_FORMAT)}
        </>
      );
    }
    return filter.label;
  }, [filter.value, isCustomOpen, isOpen]);

  const onClickClose = (event: MouseEvent<SVGSVGElement>) => {
    event.stopPropagation();
    closeCustom && closeCustom();
  };

  return (
    <div
      className={cn('flex items-center bg-white', {
        'cursor-pointer': !isCustomOpen
      })}
    >
      <CalendarIcon
        className={cn('-m-1 w-6', {
          'stroke-content-subtle': disabled
        })}
      />
      <div
        className={cn('mx-2 flex grow items-center truncate text-sm', {
          'text-content-subtle': disabled
        })}
      >
        {label}
      </div>
      {isCustomOpen ? (
        <XMarkIcon
          className="-m-1 w-8 cursor-pointer stroke-1"
          onClick={onClickClose}
        />
      ) : (
        <ChevronUpIcon
          className={cn('-m-1 w-6 stroke-content-subtle', {
            'scale-flip': !isOpen
          })}
        />
      )}
    </div>
  );
};
